var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { clearAccessTokenCookie } from '@libs/utils/serverHelpers';
import BaseLoading from '@libs/@core/components/loading/BaseLoading';
export var checkLocalStorage = function (_a) {
    var params = _a.params, Component = _a.component, props = _a.props, callBackNavigate = _a.callBackNavigate;
    if (params.includes('/auth')) {
        return _jsx(Component, __assign({}, props));
    }
    else {
        clearAccessTokenCookie();
        setTimeout(function () {
            callBackNavigate();
        }, 1000);
        return _jsx(BaseLoading, {});
    }
};
export var checkComponent = function (_a) {
    var params = _a.params, Component = _a.component, props = _a.props;
    if (params.includes('/auth')) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    else {
        return _jsx(Component, __assign({}, props));
    }
};
export var checkUserToken = function (_a) {
    var data = _a.data, params = _a.params, Component = _a.component, props = _a.props, callBackNavigate = _a.callBackNavigate;
    var isLoading = data.isLoading, isError = data.isError, isSuccess = data.isSuccess;
    if (isLoading) {
        return _jsx(BaseLoading, {});
    }
    if (isError) {
        return checkLocalStorage({
            params: params,
            component: Component,
            callBackNavigate: callBackNavigate,
            props: props
        });
    }
    if (isSuccess) {
        return checkComponent({
            params: params,
            component: Component,
            props: props
        });
    }
    return _jsx(Component, __assign({}, props));
};
